import React from "react";
import { Star, Quote } from "lucide-react";

export default function Testimonials({ items }) {
    if (!items || items.length === 0) return null;
    return (
        <section id="reviews" className="relative bg-black border-t border-zinc-900">
            <div className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32">
                <div className="grid md:grid-cols-12 gap-10 items-end mb-16">
                    <div className="md:col-span-7">
                        <div className="flex items-center gap-3 mb-6">
                            <span className="h-px w-10 bg-yellow-400" />
                            <span className="font-mono-accent text-[11px] text-yellow-400">
                                04 / Reviews
                            </span>
                        </div>
                        <h2
                            data-testid="reviews-heading"
                            className="font-display text-white text-5xl md:text-7xl lg:text-8xl"
                        >
                            What neighbors <span className="text-yellow-400">say</span>.
                        </h2>
                    </div>
                </div>

                <div className="grid md:grid-cols-3 gap-4">
                    {items.map((t, i) => (
                        <div
                            key={t.id || i}
                            data-testid={`testimonial-${i}`}
                            className="relative border border-zinc-900 bg-[#0a0a0a] p-8 md:p-10 hover:border-yellow-400 transition-colors"
                        >
                            <Quote className="absolute top-6 right-6 w-10 h-10 text-yellow-400/20" />
                            <div className="flex gap-1 mb-6">
                                {[...Array(t.rating || 5)].map((_, k) => (
                                    <Star key={k} className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                                ))}
                            </div>
                            <p className="text-zinc-200 text-lg leading-relaxed">
                                “{t.quote}”
                            </p>
                            <div className="mt-8 pt-6 border-t border-zinc-900">
                                <div className="font-display text-white text-2xl">{t.name}</div>
                                <div className="font-mono-accent text-[10px] text-zinc-500 mt-1">
                                    {t.location}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
